import { render, staticRenderFns } from "./FormularioArea.vue?vue&type=template&id=4bbd721a&"
import script from "./FormularioArea.vue?vue&type=script&lang=js&"
export * from "./FormularioArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports